import {DatabaseCode, toDatabaseCode} from "./database-code";

/**
 * The category of transport
 */
export interface TicketValidationStatus extends DatabaseCode {
}

const pending: TicketValidationStatus = {
  code: 'PENDING',
  displayValue: {
    id: 'common.entity.tta.validation.status.pending',
    defaultMessage: 'Pending Validation',
  },
};

const disputed: TicketValidationStatus = {
  code: 'DISPUTED',
  displayValue: {
    id: 'common.entity.tta.validation.status.disputed',
    defaultMessage: 'Disputed',
  },
};

const adminValidated: TicketValidationStatus = {
  code: 'ADMIN_VALIDATED',
  displayValue: {
    id: 'common.entity.tta.validation.status.adminvalidated',
    defaultMessage: 'Admin Validated',
  },
};

const dispatchValidated: TicketValidationStatus = {
  code: 'DISPATCH_VALIDATED',
  displayValue: {
    id: 'common.entity.tta.validation.status.dispatchvalidated',
    defaultMessage: 'Dispatch Validated',
  },
};

const fieldValidated: TicketValidationStatus = {
  code: 'FIELD_VALIDATED',
  displayValue: {
    id: 'common.entity.tta.validation.status.fieldvalidated',
    defaultMessage: 'Field Validated',
  },
};

const businessValidated: TicketValidationStatus = {
  code: 'BUSINESS_VALIDATED',
  displayValue: {
    id: 'common.entity.tta.validation.status.businessvalidated',
    defaultMessage: 'Business Validated',
  },
};

export const ticketValidationStatus = {
  pending,
  disputed,
  adminValidated,
  dispatchValidated,
  fieldValidated,
  businessValidated,
};

export const ticketValidationStatuses = Object.values(ticketValidationStatus);

export const toTicketValidationStatus = (code: string): TicketValidationStatus => toDatabaseCode(code, ticketValidationStatuses);
